// componente che contiene i metodi che permettono di interagire col back-end (richieste HTTP)

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { SchedulerService } from '../view/pages/dashboard/scheduler.service';
import { BodyService } from '../view/pages/body/body.service';

import { GroupsService } from '../view/pages/groups/groups.service';
import { UsersService } from '../view/pages/usersnew/users.service';
import { AlarmcodesService } from '../view/pages/alarmcodes/alarmcodes.service';
import { AvailablesService } from '../view/pages/availables/availables.service';
import { ExceptionsService } from '../view/pages/exceptions/exceptions.service';
import { PlantsService } from '../view/pages/plants/plants.service';
import { CallstatusService } from '../view/pages/callstatus/callstatus.service';
import { TtsService } from '../view/pages/tts/tts.service';
import { EmergenciesstatusService } from '../view/pages/emergenciesstatus/emergenciesstatus.service';
import { SettingsService } from '../view/pages/settings/settings.service';
import { EmergenciesnotmanagedService } from '../view/pages/emergenciesnotmanaged/emergenciesnotmanaged.service';
import { TtssettingsService } from '../view/pages/ttssettings/ttssettings.service';
import { BackupService } from '../view/pages/backup/backup.service';
import { EmailService } from '../view/pages/email/email.service';


// classe User utilizzata per definire il contenuto degli oggetti di tipo utente scambiati col back-end
export class User {
    username: string;
    telephone: string;
    email: string;
    bodyid: string;
    firstname: string;
    lastname: string;
    profile: string;
    token: string;
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    public token: string
    constructor(
        private http: HttpClient,
        private userService: UsersService,
        private callstatusService: CallstatusService,
        private ttsService: TtsService,
        private emergenciesstatusService: EmergenciesstatusService,
        private schedulerService: SchedulerService,
        private groupsService: GroupsService,
        private alarmcodesService: AlarmcodesService,
        private availablesService: AvailablesService,
        private exceptionsService: ExceptionsService,
        private plantsService: PlantsService,
        private bodyService: BodyService,
        private settingsService: SettingsService,
        private emergenciesnotmanagedService: EmergenciesnotmanagedService,
        private ttssettingsService: TtssettingsService,
        private backupService: BackupService,
        private emailService: EmailService,


    ) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    callstatusdashboard(timeFilter, plantFilter, availableFilter): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/callstatusdashboard`,
            { "timeFilter": timeFilter, "plantFilter": plantFilter, "availableFilter": availableFilter },
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    piedata(): Observable<any> {
        return this.http.get<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/piedata`,
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    
    emergenciesdashboard(timeFilter, plantFilter, availableFilter): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesdashboard`,
            { "timeFilter": timeFilter, "plantFilter": plantFilter, "availableFilter": availableFilter },
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    availablesdashboard(): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/availablesdashboard`,
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    availablesdashboardmonth(): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/availablesdashboardmonth`,
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    availablesdashboardtot(): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/availablesdashboardtot`,
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    /* ----------METODI DI GESTIONE UTENTI---------- */

    // login alla piattaforma
    login(username, password) {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/signin`,
            { "username": username, "password": password },
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }



    // creazione nuovo utente 
    register(user) {
        return this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/users', user, { withCredentials: true, responseType: 'text' });
    };

    // creazione nuovo utente 
    storeUsers(user) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/users', user, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // restituisce tutti gli utenti
    getUsers() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/users', { withCredentials: true }).subscribe(

            res => {
                this.userService.setUsers(res)
            }
        )
    }
    getUsersList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/userslist', {
            withCredentials: true
        })
    }
    whoami(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/whoami', {
            withCredentials: true
        })
    }
    // cancellazione utente
    deleteUser(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/user/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione utente
    deleteUsers(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/user/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // aggiornamento utente
    updatePersonal(user) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/personal', user, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // aggiornamento utente
    updateUsers(user) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/users', user, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // restituisce le info dell'utente che lo richiama (leggendole dal JWT contenuto nell'header)
    returnUser(): Promise<any> {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/users', { withCredentials: true })
            .toPromise()
            .then(res => {
                if (JSON.stringify(res) == "No document found") {
                    return []
                } else {
                    this.userService.setUsers(res)
                    return res
                }
            })
    }
    // recupero credenziali
    recover(id): Observable<any> {
        return this.http.post<any>(
            'https://sosimperium.multiutilitydelgarda.eu:8001/recover',
            { ...{ "id": id } },
            {
                //@ts-ignore 
                responseType: 'text',
                withCredentials: true
            }
        );
    }
    // restituisce l'ID massimo degli utenti già presenti nel back-end (incrementato di 1)
    getMaxUsers(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxusers', {
            withCredentials: true
        })
    }
    getEmergenciesnotmanagedColumn(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesnotmanagedcolumn', {
            withCredentials: true
        })
    }
    getCallColumn(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/callstatuscolumn', {
            withCredentials: true
        })
    }
    getEmergencyColumn(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergencycolumn', {
            withCredentials: true
        })
    }
    getTtsColumn(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/ttscolumn', {
            withCredentials: true
        })
    }
    getEmailColumn(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emailcolumn', {
            withCredentials: true
        })
    }
    /* ----------METODI DI GESTIONE REPERIBILI---------- */

    // creazione nuovo tipo endpoint
    storeAvailables(endpoint) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/availables', endpoint, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // aggiornamento tipo endpoint
    updateAvailables(endpoint) {
        endpoint.id = parseInt(endpoint.id)
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        //@ts-ignore 
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/availables', endpoint, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deleteAvailables(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/availables/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }

    // restituisce tutti i tipi endpoint
    getAvailables() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/availables', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.availablesService.setAvailables(res)
            }
        )
        return ret
    }
    getAvailablesTot(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/availables', {
            withCredentials: true
        })
    }
    getAvailablesList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/availableslist', {
            withCredentials: true
        })
    }
    // restituisce l'ID massimo dei tipi endpoint già presenti nel back-end (incrementato di 1)
    getMaxAvailables(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxavailables', {
            withCredentials: true
        })
    }

    /* ----------METODI DI GESTIONE CODICI ALLARME---------- */

    // creazione nuovo tipo endpoint
    storeAlarmcodes(endpoint) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/alarmcodes', endpoint, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // aggiornamento tipo endpoint
    updateAlarmcodes(endpoint) {
        endpoint.id = parseInt(endpoint.id)
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        //@ts-ignore 
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/alarmcodes', endpoint, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deleteAlarmcodes(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/alarmcodes/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // restituisce tutti i tipi endpoint
    getAlarmcodes() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/alarmcodes', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.alarmcodesService.setAlarmcodes(res)
            }
        )
        return ret
    }
    getAlarmcodesTot(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/alarmcodes', {
            withCredentials: true
        })
    }
    getAlarmcodesList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/alarmcodeslist', {
            withCredentials: true
        })
    }
    // restituisce l'ID massimo dei tipi endpoint già presenti nel back-end (incrementato di 1)
    getMaxAlarmcodes(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxalarmcodes', {
            withCredentials: true
        })
    }

    /* ----------METODI DI GESTIONE ECCEZIONI REPERIBILI---------- */

    // creazione nuovo tipo endpoint
    storeExceptions(endpoint) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/exceptions', endpoint, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // aggiornamento tipo endpoint
    updateExceptions(endpoint) {
        endpoint.id = parseInt(endpoint.id)
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        //@ts-ignore 
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/exceptions', endpoint, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deleteExceptions(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/exceptions/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // restituisce tutti i tipi endpoint
    getExceptions() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/exceptions', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.exceptionsService.setExceptions(res)
            }
        )
        return ret
    }
    getExceptionsList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/exceptionslist', {
            withCredentials: true
        })
    }
    // restituisce l'ID massimo dei tipi endpoint già presenti nel back-end (incrementato di 1)
    getMaxExceptions(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxexceptions', {
            withCredentials: true
        })
    }

    /* ----------METODI DI GESTIONE IMPIANTI---------- */

    // creazione nuovo tipo endpoint
    storePlants(endpoint) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/plants', endpoint, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // aggiornamento tipo endpoint
    updatePlants(endpoint) {
        endpoint.id = parseInt(endpoint.id)
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        //@ts-ignore 
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/plants', endpoint, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deletePlants(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/plants/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // restituisce tutti i tipi endpoint
    getPlants() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/plants', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.plantsService.setPlants(res)
            }
        )
        return ret
    }
    getPlantsTot(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/plants', {
            withCredentials: true
        })
    }
    getPlantsList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/plantslist', {
            withCredentials: true
        })
    }
    // restituisce l'ID massimo dei tipi endpoint già presenti nel back-end (incrementato di 1)
    getMaxPlants(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxplants', {
            withCredentials: true
        })
    }


    /* ----------METODI DI GESTIONE GRUPPI---------- */

    // creazione nuovo tipo endpoint
    storeGroups(endpoint) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/groups', endpoint, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // aggiornamento tipo endpoint
    updateGroups(endpoint) {
        endpoint.id = parseInt(endpoint.id)
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        //@ts-ignore 
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/groups', endpoint, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deleteGroups(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/groups/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // restituisce tutti i tipi endpoint
    getGroups() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/groups', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.groupsService.setGroups(res)
            }
        )
        return ret
    }
    getGroupsTot(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/groups', {
            withCredentials: true
        })
    }
    getGroupsList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/groupslist', {
            withCredentials: true
        })
    }
    // restituisce l'ID massimo dei tipi endpoint già presenti nel back-end (incrementato di 1)
    getMaxGroups(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxgroups', {
            withCredentials: true
        })
    }


    /* ----------METODI DI GESTIONE CALENDARIO---------- */

    // creazione nuovo tipo endpoint
    storeScheduler(endpoint) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/availabilities', endpoint, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // aggiornamento tipo endpoint
    updateScheduler(endpoint) {
        endpoint.id = parseInt(endpoint.id)
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        //@ts-ignore 
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/availabilities', endpoint, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deleteScheduler(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/availabilities/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deleteSchedulers(mess) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/deleteavailabilities', mess, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // restituisce tutti i tipi endpoint
    getScheduler(el) {
        el ? el = el : el = "0_0"
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/availabilitiess/' + el, { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.schedulerService.setScheduler(res)
            }
        )
        return ret
    }
    getSchedulerr(month, year): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/availabilitiess/' + month + "_" + year, {
            withCredentials: true
        })
    }
    // getSchedule(id) {
    //     return this.http.get('https://sosimperium.multiutilitydelgarda.eu:8001/availabilities/' + id, {
    //         withCredentials: true
    //     });
    // };
    getSchedule(message): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/findavailabilities`,
            message,
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    getSchedulerList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/availabilitieslist', {
            withCredentials: true
        })
    }
    // restituisce l'ID massimo dei tipi endpoint già presenti nel back-end (incrementato di 1)
    getMaxScheduler(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxavailabilities', {
            withCredentials: true
        })
    }
    // restituisce l'ID massimo dei tipi endpoint già presenti nel back-end (incrementato di 1)
    getMaxBody(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/maxbody', {
            withCredentials: true
        })
    }

    // restituisce tutti i tipi endpoint
    getCallstatus(pageIndex, pageSize, filter): Observable<any> {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.post<any>('https://sosimperium.multiutilitydelgarda.eu:8001/callstatus/' + pageIndex + '/' + pageSize, filter, { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.callstatusService.setCallstatus(res.data)
                res.count ? this.callstatusService.setCallstatuscount(res.count[0].count) : this.callstatusService.setCallstatuscount("0")
            }
        )
        return ret
    }

    getTts(pageIndex, pageSize, filter): Observable<any> {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.post<any>('https://sosimperium.multiutilitydelgarda.eu:8001/tts/' + pageIndex + '/' + pageSize, filter, { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.ttsService.setTts(res.data)
                res.count ? this.ttsService.setTtscount(res.count[0].count) : this.ttsService.setTtscount("0")
            }
        )
        return ret
    }

    getEmail(pageIndex, pageSize, filter): Observable<any> {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.post<any>('https://sosimperium.multiutilitydelgarda.eu:8001/email/' + pageIndex + '/' + pageSize, filter, { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.emailService.setEmail(res.data)
                res.count ? this.emailService.setEmailcount(res.count[0].count) : this.emailService.setEmailcount("0")
            }
        )
        return ret
    }

    

    resend(message): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/resend`,
            message,
            {
                observe: 'response',
                withCredentials: true
            }
        );
    }
    getCallstatuscount() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/callstatuscount', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.callstatusService.setCallstatuscount(res)
            }
        )
        return ret
    }
    getTtscount() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/ttscount', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.ttsService.setTtscount(res)
            }
        )
        return ret
    }

    getEmailcount() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emailcount', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.emailService.setEmailcount(res)
            }
        )
        return ret
    }

    getEmergenciesstatus(pageIndex: number, pageSize: number, filter: any): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesstatus/${pageIndex}/${pageSize}`,
            filter,
            { withCredentials: true }
        );
    }    

    // // restituisce tutti i tipi endpoint
    // getEmergenciesstatus(pageIndex, pageSize, filter): Observable<any> {
    //     let headers = new Headers()
    //     headers.append('Content-Type', 'application/json')
    //     var ret
    //     this.http.post<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesstatus/' + pageIndex + '/' + pageSize, filter, { withCredentials: true }).subscribe(
    //         res => {
    //             ret = res
    //             this.emergenciesstatusService.setEmergenciesstatus(res.data)
    //             res.count ? this.emergenciesstatusService.setEmergenciesstatuscount(res.count[0].count) : this.emergenciesstatusService.setEmergenciesstatuscount("0")
    //         }
    //     )
    //     return ret
    // }
    getEmergenciesstatusmobile(pageIndex, pageSize, filter): Observable<any> {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.post<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesstatusmobile/' + pageIndex + '/' + pageSize, filter, { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.emergenciesstatusService.setEmergenciesstatus(res.data)
                res.count ? this.emergenciesstatusService.setEmergenciesstatuscount(res.count[0].count) : this.emergenciesstatusService.setEmergenciesstatuscount("0")
            }
        )
        return ret
    }
    getCallstatusmobile(pageIndex, pageSize, filter): Observable<any> {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.post<any>('https://sosimperium.multiutilitydelgarda.eu:8001/callstatusmobile/' + pageIndex + '/' + pageSize, filter, { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.callstatusService.setCallstatus(res.data)
                res.count ? this.callstatusService.setCallstatuscount(res.count[0].count) : this.callstatusService.setCallstatuscount("0")
            }
        )
        return ret
    }

    getEmergenciesnotmanaged(pageIndex: number, pageSize: number, filter: any): Observable<any> {
        return this.http.post<any>(
            `https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesnotmanaged/${pageIndex}/${pageSize}`,
            filter,
            { withCredentials: true }
        );
    }    
    
    getEmergenciesstatustot(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesstatustot', {
            withCredentials: true
        })
    }
    getEmergenciesnotmanagedtot(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesnotmanagedtot', {
            withCredentials: true
        })
    }
    getEmergenciesnotmanagedcountt(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesnotmanagedcount', {
            withCredentials: true
        })
    }
    getEmergenciesnotmanagedcount() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesnotmanagedcount', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.emergenciesnotmanagedService.setEmergenciesnotmanaged(res)
            }
        )
        return ret
    }

    getEmergenciesstatuscountt(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesstatuscount', {
            withCredentials: true
        })
    }

    getEmergenciesstatuscount() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/emergenciesstatuscount', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.emergenciesstatusService.setEmergenciesstatuscount(res)
            }
        )
        return ret
    }

    /* ----------METODI DI GESTIONE ENTI---------- */

    // creazione nuovo tipo endpoint
    storeBody(endpoint) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/body', endpoint, { withCredentials: true, responseType: 'text' }).subscribe()
    }
    // aggiornamento tipo endpoint
    updateBody(endpoint) {
        endpoint.id = parseInt(endpoint.id)
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        //@ts-ignore 
        this.http.put('https://sosimperium.multiutilitydelgarda.eu:8001/body', endpoint, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // cancellazione tipo endpoint
    deleteBody(id) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        this.http.delete('https://sosimperium.multiutilitydelgarda.eu:8001/body/' + id, { withCredentials: true, responseType: 'text' }).subscribe(
            res => {
            }
        )
    }
    // restituisce tutti i tipi endpoint
    getBody() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/body', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.bodyService.setBody(res)
            }
        )
        return ret
    }
    getBodyTot(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/body', {
            withCredentials: true
        })
    }
    getBodyList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/bodylist', {
            withCredentials: true
        })
    }

    getTagList(): Observable<any> {
        return this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/taglist', {
            withCredentials: true
        })
    }
    // creazione nuovo tipo endpoint
    storeCsvAlarmcodes(endpoint) {
        let headers = new HttpHeaders()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/csvalarmcodes', endpoint, { headers: headers, withCredentials: true, responseType: 'json' }).subscribe()
    }
    // creazione nuovo tipo endpoint
    storeCsvAvailabilities(endpoint) {
        let headers = new HttpHeaders()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/csvavailabilities', endpoint, { headers: headers }).subscribe()
    }
    // creazione nuovo tipo endpoint
    storeCsvGroups(endpoint) {
        let headers = new HttpHeaders()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/csvgroups', endpoint, { headers: headers }).subscribe()
    }
    // creazione nuovo tipo endpoint
    storeCsvPlants(endpoint) {
        let headers = new HttpHeaders()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/csvplants', endpoint, { headers: headers }).subscribe()
    }
    // creazione nuovo tipo endpoint
    storeCsvExceptions(endpoint) {
        let headers = new HttpHeaders()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/csvexceptions', endpoint, { headers: headers }).subscribe()
    }
    // creazione nuovo tipo endpoint
    storeCsvAvailables(endpoint) {
        let headers = new HttpHeaders()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/csvavailables', endpoint, { headers: headers }).subscribe()
    }
    // creazione nuovo tipo endpoint
    storeCsvBody(endpoint) {
        let headers = new HttpHeaders()
        headers.append('Content-Type', 'application/json')
        this.http.post('https://sosimperium.multiutilitydelgarda.eu:8001/csvbody', endpoint, { headers: headers }).subscribe()
    }


    /* ----------METODI DI GESTIONE IMPOSTAZIONI---------- */

    // aggiornamento tipo endpoint



    updateSetting(res) {
        return this.http.put(
            'https://sosimperium.multiutilitydelgarda.eu:8001/settings',
            { ...res },
            {
                responseType: 'text',
                withCredentials: true
            }
        );
    }
    updateTtssetting(res) {
        return this.http.put(
            'https://sosimperium.multiutilitydelgarda.eu:8001/ttssettings',
            { ...res },
            {
                responseType: 'text',
                withCredentials: true
            }
        );
    }
    // restituisce tutti i tipi endpoint
    getSettings() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/settings', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.settingsService.setSettings(res)
            }
        )
        return ret
    }
    getBackup() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/backup', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.backupService.setBackup(res)
            }
        )
        return ret
    }
    updateBackup(res) {
        return this.http.put(
            'https://sosimperium.multiutilitydelgarda.eu:8001/backup',
            { ...res },
            {
                responseType: 'text',
                withCredentials: true
            }
        );
    }
    getTtssettings() {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        var ret
        this.http.get<any>('https://sosimperium.multiutilitydelgarda.eu:8001/ttssettings', { withCredentials: true }).subscribe(
            res => {
                ret = res
                this.ttssettingsService.setTtssettings(res)
            }
        )
        return ret
    }
}